import {getRoleRank} from '../utils';

import type {FirmMemberDTO} from '@sollapay/types';
import type {ListSortConfig} from '@sollapay/ui/components';

export const TEAM_SORT_CONFIG: ListSortConfig<FirmMemberDTO> = {
  order: ['createdAt', 'member', 'role', 'status', 'lastLoginAt'],
  fields: {
    createdAt: {
      i18nKey: 'sorting.createdAt',
      defaultDesc: true,
      getValue: row => new Date(row.createdAt).getTime()
    },
    member: {
      i18nKey: 'sorting.member',
      defaultDesc: false,
      getValue: row => row.name ?? row.email
    },
    role: {
      i18nKey: 'sorting.role',
      defaultDesc: false,
      getValue: row => getRoleRank(row.roleKey) ?? null
    },
    status: {
      i18nKey: 'sorting.status',
      defaultDesc: false,
      getValue: row => row.status
    },
    lastLoginAt: {
      i18nKey: 'sorting.lastLoginAt',
      defaultDesc: true,
      getValue: row => (row.lastLoginAt ? new Date(row.lastLoginAt).getTime() : null)
    }
  }
};
